'use client';

import { c as _c } from "react/compiler-runtime";
import type { RefObject } from 'react';
import { useCallback, useEffect, useLayoutEffect, useState } from 'react';
export const useArrowPosition = (slideRef, arrowVerticalPosition, overflowDesktop) => {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      vertical: "0px",
      horizontal: "0px"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [arrowPosition, setArrowPosition] = useState(t0);
  let t1;
  if ($[1] !== arrowVerticalPosition || $[2] !== overflowDesktop || $[3] !== slideRef) {
    t1 = () => {
      const firstImage = slideRef.current?.[0]?.querySelector("img, video, div[style*=\"background-image\"]") as HTMLElement;
      const imageHeight = firstImage?.offsetHeight;
      const slideHeight = slideRef.current?.[0]?.offsetHeight;
      const positions = {
        image: imageHeight ? imageHeight / 2 - 20 : 0,
        slide: slideHeight ? slideHeight / 2 - 20 : 0
      };
      setArrowPosition({
        vertical: positions[arrowVerticalPosition] + "px",
        horizontal: overflowDesktop ? "11.5%" : "calc(-1 * var(--arrow-size) - var(--arrow-offset-x))"
      });
    };
    $[1] = arrowVerticalPosition;
    $[2] = overflowDesktop;
    $[3] = slideRef;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const updateSize = t1;
  let t2;
  if ($[5] !== updateSize) {
    t2 = () => {
      window.addEventListener("resize", updateSize);
      return () => {
        window.removeEventListener("resize", updateSize);
      };
    };
    $[5] = updateSize;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== overflowDesktop || $[8] !== updateSize) {
    t3 = [overflowDesktop, updateSize];
    $[7] = overflowDesktop;
    $[8] = updateSize;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  useLayoutEffect(t2, t3);
  let t4;
  let t5;
  if ($[10] !== updateSize) {
    t4 = () => {
      setTimeout(() => {
        updateSize();
      }, 1);
    };
    t5 = [updateSize];
    $[10] = updateSize;
    $[11] = t4;
    $[12] = t5;
  } else {
    t4 = $[11];
    t5 = $[12];
  }
  useEffect(t4, t5);
  return arrowPosition;
};